import React, { memo } from "react";
import { getEndPoints } from "../../../helpers/helpers";
import styles from "./Card.module.css";
const camelTotitle = (camelCase) => {
  return camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
};

const Card = ({ data, cardColor, cardBgColor, base_url }) => {
  const { title, ...rest } = data;
  return (
    <div className={styles.container}>
      <div
        className={styles.card}
        style={{ borderColor: cardColor, backgroundColor: cardBgColor }}
      >
        <div className={styles.cardTitle}>
          <strong>{camelTotitle(title).toUpperCase()}</strong>
        </div>
        <hr />
        {Object.entries(rest).map(([key, val]) => (
          <div className={styles.cardBody} key={key}>
            <div>
              <a
                href={base_url + getEndPoints(key)}
                target="_blank"
                rel="noreferrer"
                style={{
                  textDecoration: "underline",
                  textDecorationColor: "blue",
                }}
              >
                <small style={{ textDecoration: "underline" }}>
                  {camelTotitle(key)}
                </small>
              </a>
            </div>

            <div>
              <div className={styles.badge}>{val}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(Card);
